import { render, staticRenderFns } from "./WaterHeatingSystem.vue?vue&type=template&id=2e506f5d"
import script from "./WaterHeatingSystem.vue?vue&type=script&lang=js"
export * from "./WaterHeatingSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports